import { render } from "./static-page-delete.vue?vue&type=template&id=4fa7be02"
import script from "./static-page-delete.vue?vue&type=script&lang=js"
export * from "./static-page-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__